/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Add"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Remove all"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var enGB = Object.assign(TranslationProviderComponent, {
  translations
});

export { enGB as e };
//# sourceMappingURL=en-GB-Bo4DMKCX.js.map
